import { Stack, XStack } from '@my/ui'
import useEmblaCarousel from 'embla-carousel-react'
import { NavCarouselItem } from './nav-carousel-item'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import { NavCarouselProps } from './nav-carousel'

export const NavCarouselItems = ({ items, currentSelectedItem }: NavCarouselProps) => {
  const [emblaRef] = useEmblaCarousel(
    {
      active: true,
      slidesToScroll: 1,
      containScroll: 'trimSnaps',
      skipSnaps: true,
      align: 'start',
      // startIndex: items.findIndex((item) => item.href === currentSelectedItem?.href),
    },
    [WheelGesturesPlugin()]
  )

  return (
    <Stack flex={1} ref={emblaRef as any}>
      <XStack height="auto" style={{ backfaceVisibility: 'hidden' }}>
        {items.map((item, index) => (
          <NavCarouselItem
            minWidth={0}
            flexGrow={0}
            flexShrink={0}
            flexBasis="auto"
            key={`nav-carousel-item${index}`}
            href={item.href}
            label={item.label}
            Icon={item.Icon}
            active={currentSelectedItem?.href === item.href}
          />
        ))}
      </XStack>
    </Stack>
  )
}
